import React, { FC } from 'react';

import { Box, ListItem, OrderedList } from '@chakra-ui/react';

import { CustomTooltip, formatTooltip } from 'components/DataDisplay';

import { NamedRef } from './types';

interface Props {
  items?: NamedRef[];
  header: string;
  label: string;
}

// Table cell showing a summary of a list ("2 groups", "3") with the full
// numbered list in a tooltip; '-' when empty.
export const NamedListCell: FC<Props> = props => {
  const { items = [], header, label } = props;
  if (!items.length) return <Box>-</Box>;

  return (
    <CustomTooltip
      label={formatTooltip({
        header,
        width: 48,
        content: (
          <OrderedList spacing={1}>
            {items.map(item => (
              <ListItem key={item.uuid}>{item.name}</ListItem>
            ))}
          </OrderedList>
        ),
      })}
    >
      <Box as="span" cursor="default">
        {label}
      </Box>
    </CustomTooltip>
  );
};
